__turbopack_context__.v({
  "container": "CloudinaryMedia-module__cse4lG__container",
  "fadeInItems": "CloudinaryMedia-module__cse4lG__fadeInItems",
  "spacing--lg": "CloudinaryMedia-module__cse4lG__spacing--lg",
  "spacing--md": "CloudinaryMedia-module__cse4lG__spacing--md",
  "spacing--sm": "CloudinaryMedia-module__cse4lG__spacing--sm",
  "spacing--xl": "CloudinaryMedia-module__cse4lG__spacing--xl",
  "spacing--xs": "CloudinaryMedia-module__cse4lG__spacing--xs",
  "spacing--xxl": "CloudinaryMedia-module__cse4lG__spacing--xxl",
  "spacing--xxs": "CloudinaryMedia-module__cse4lG__spacing--xxs",
  "spacing--xxxl": "CloudinaryMedia-module__cse4lG__spacing--xxxl",
  "spacing--xxxs": "CloudinaryMedia-module__cse4lG__spacing--xxxs",
});
